/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-22T09:43:58.065
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listEvaluationRent,
	listEvaluationRentInit,
	listEvaluationRentByAuthorizations,
	deleteEvaluationRent
} from '@api/lcf/EvaluationRent';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listEvaluationRent({
			state
		}) {
			return new Promise((resolve, reject) => {
				listEvaluationRent(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listEvaluationRentByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listEvaluationRentByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listEvaluationRentInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listEvaluationRentInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteEvaluationRent({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteEvaluationRent({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
